























































import { Component, Vue } from 'vue-property-decorator';
import TokenService from '@/services/token';
import router from '../router';
@Component
export default class Login extends Vue {
  public email: string;
  public password: string;
  public loadingLogin: boolean;
  public loginErrorSnackBar = false;
  public snackBarTimeout: number = 5000;
  private tokenService: TokenService;

  constructor() {
    super();
    this.email = '';
    this.password = '';
    this.loadingLogin = false;
    this.tokenService = new TokenService();
  }
  public async login() {
    this.loadingLogin = true;
    const result = await this.tokenService.axiosLogin(
      this.email,
      this.password,
    );
    this.loadingLogin = false;
    if (result) {
      router.push({ name: 'Dashboard' });
    } else {
      this.loginErrorSnackBar = true;
    }
  }
}
